import { Input, Typography } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import SelectComp from "../../../commons/Select/Select";
import GeneralModal from "../General.modal";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { useTranslation } from "react-i18next";

const UpdateDesignation = ({ updateParent, data, departments }) => {
  const { t } = useTranslation("dashboard");
  const { Title } = Typography;

  const [formData, setFormData] = useState({
    title: "",
    departmentId: ""
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (key, val) => {
    setFormData(prev => ({
      ...prev,
      [key]: val
    }));
  };

  const onSubmit = async () => {
    await axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/designations/update/${data?._id}`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    if (data) {
      setFormData({
        title: data?.title || "",
        departmentId: data?.department?._id || ""
      });
    }
  }, [data]);

  const items = (
    <div className="row form-row">
      <div className="col-12 col-sm-12">
        <div className="form-group">
          <Title level={5} className="modals-inputs-label">
            {t("Department")}
          </Title>

          <SelectComp
            key={formData.departmentId}
            value={formData.departmentId}
            handleChange={val => handleChange("departmentId", val)}
            options={departments}
            placeholder={t("Select Department")}
          />
        </div>

        <div className="form-group">
          <Title level={5} className="modals-inputs-label">
            {t("Title")}
          </Title>
          <Input
            value={formData.title}
            onChange={e => handleChange("title", e.target.value)}
            type="text"
            className="w-100"
            allowClear
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="UpdateDesignation">
      <MainButtonComp text="Edit" editBtn onClick={showModal} />

      <GeneralModal
        title={t("Update Designation")}
        onOk={onSubmit}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        items={items}
      />
    </div>
  );
};

export default UpdateDesignation;
